import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { supabase } from '../utils/supabaseClient';
import { BookingWithAccommodation } from '../utils/supabaseExtended';
import Layout from '../components/layout/Layout';
import { formatPrice } from '../utils/config';

const DetailsContainer = styled.div`
  max-width: 900px;
  margin: 2rem auto;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.1);
`;

const Loading = styled.p`
  text-align: center;
  font-size: 1.5rem;
  padding: 4rem;
`;

const ErrorMessage = styled.p`
  text-align: center;
  font-size: 1.5rem;
  padding: 4rem;
  color: red;
`;

const BookingDetails: React.FC = () => {
  const { bookingId } = useParams<{ bookingId: string }>();
  const [booking, setBooking] = useState<BookingWithAccommodation | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBookingDetails = async () => {
      if (!bookingId) {
        setError('ID prenotazione non trovato.');
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('bookings')
          .select(`
            *,
            accommodations (
              title_it,
              image
            )
          `)
          .eq('id', bookingId)
          .single();

        if (error) {
          throw new Error('Prenotazione non trovata o non hai i permessi per visualizzarla.');
        }

        setBooking(data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBookingDetails();
  }, [bookingId]);

  if (loading) {
    return <Layout><Loading>Caricamento dettagli prenotazione...</Loading></Layout>;
  }

  if (error) {
    return <Layout><ErrorMessage>{error}</ErrorMessage></Layout>;
  }

  if (!booking) {
    return <Layout><ErrorMessage>Impossibile caricare i dati della prenotazione.</ErrorMessage></Layout>;
  }

  return (
    <Layout>
      <DetailsContainer>
        <h1>Dettaglio Prenotazione #{booking.id.slice(0, 8)}</h1>
        <h2>{booking.accommodations?.title_it}</h2>

        <p><strong>Check-in:</strong> {new Date(booking.check_in).toLocaleDateString('it-IT')}</p>
        <p><strong>Check-out:</strong> {new Date(booking.check_out).toLocaleDateString('it-IT')}</p>
        <p><strong>Ospiti:</strong> {booking.guests_count}</p>
        <p><strong>Stato:</strong> {booking.status}</p>
        <p><strong>Prezzo Totale:</strong> {formatPrice(booking.total_price)}</p>
      </DetailsContainer>
    </Layout>
  );
};

export default BookingDetails;
